export const LOGIN_ACTION='[action] login user';
export const LOGOUT_ACTION='[action] logout user';
export const AUTO_LOGIN_ACTION='[action] auto login user';
export const AUTO_LOGOUT_ACTION='[action] auto logout user';
export const SET_USER_DETAILS='[mutations] logged in user details';
export const GET_USER_DETAILS='[getters] logged in user details';  
export const SET_USER_TOKEN='[mutations] logged in user token';  
export const SET_AUTO_LOGOUT_MUTATION='[mutations] auto log out';
export const GET_USER_TOKEN='[getters] logged in user token';  
export const IS_AUTH_USER='[getters] check user has token or not';   
